import ProductDetailsActionTypes from '../actionTypes/ProductDetailsActionTypes';

const defaultState = {};

const ProductDetailsReducer = function ProductDetailsReducer(state, action) {
    switch (action.type) {
        case ProductDetailsActionTypes.PRODUCTDETAILS_GET_SUCCESS:
            return action.productDetails;
        case ProductDetailsActionTypes.PRODUCTDETAILS_RESET:
            return defaultState;
        default:
            return state;
    }
};

export default ProductDetailsReducer;
